module.exports = __webpack_public_path__ + "d905de658a9c1fe4f9d779ccb15c7433.ttf";